window.ContentSlider = (function () {
    class ContentSlider {
        private mainContainer: any;
        private outerContainer: any;
        private innerContainer: any;
        private leftArrow: any;
        private rightArrow: any;

        private scrollStep: number;

        constructor(mainContainer, scrollStep: any = 0) {
            this.mainContainer = $(mainContainer);

            this.mainContainer.addClass('content-slider');

            this.outerContainer = $('<div/>', {
                'class': 'content-slider__outer'
            });

            this.innerContainer = $('<div/>', {
                'class': 'content-slider__inner'
            });

            this.mainContainer.html(this.outerContainer.append(this.innerContainer.append(this.mainContainer.html())));

            if (scrollStep) {
                if (scrollStep === '100%') {
                    this.scrollStep = this.outerContainer.width()
                } else {
                    this.scrollStep = parseInt(scrollStep);
                }
            } else {
                this.scrollStep = this.outerContainer.width() / 2;
            }

            this.createArrows();
            this.bindUI();

            this.update();
        }

        private createArrows() {
            this.leftArrow = $('<div/>', {
                'class' : 'content-slider__arrow m-left'
            });
            this.rightArrow = $('<div/>', {
                'class' : 'content-slider__arrow m-right'
            });

            this.leftArrow.append('<svg class="icon content-slider__arrow-icon m-left"><use xlink:href="/content/cps/images/sprites/svg-icons.svg#expand"></use></svg>');
            this.rightArrow.append('<svg class="icon content-slider__arrow-icon m-right"><use xlink:href="/content/cps/images/sprites/svg-icons.svg#expand"></use></svg>');

            this.mainContainer.append(this.leftArrow);
            this.mainContainer.append(this.rightArrow);
        }

        private bindUI() {
            let self = this;

            self.leftArrow.on('click', function () {
                self.handleScroll(-self.scrollStep);
            });

            self.rightArrow.on('click', function () {
                self.handleScroll(self.scrollStep);
            });
        }

        private handleScroll(step) {
            let currentScrollLeft = this.outerContainer.scrollLeft();
            let newScrollPosition = currentScrollLeft + step;

            this.toggleArrowsVisibility(newScrollPosition);
            this.outerContainer.scrollLeft(newScrollPosition);
        }

        private toggleArrowsVisibility(scrollLeft) {
            if (scrollLeft <= 0) {
                this.leftArrow.removeClass('m-visible');
            } else {
                this.leftArrow.addClass('m-visible');
            }

            if (scrollLeft >= (this.innerContainer.width() - this.outerContainer.width())) {
                this.rightArrow.removeClass('m-visible');
            } else {
                this.rightArrow.addClass('m-visible');
            }
        }

        public update() {
            if (this.outerContainer.width() < this.innerContainer.width()) {
                this.toggleArrowsVisibility(this.outerContainer.scrollLeft());
            }
        }
    }

    $(function () {
        /*$('[content-slider]').each(function () {
            if ($(this).children(':first-child').hasClass('content-slider__outer') === false) {
                new ContentSlider(this, $(this).attr('content-slider-scroll-step'));
            }
        });*/
    });

    return {
        ContentSlider
    }
}());